import * as React from "react";
import {
  AppBar,
  Toolbar,
  Typography,
  Box,
  Drawer,
  List,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Divider,
  IconButton,
  Chip,
  CssBaseline,
  useMediaQuery,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import {
  Menu as MenuIcon,
  ChevronLeft as ChevronLeftIcon,
  Home as HomeIcon,
  PointOfSaleOutlined as PosIcon,
  ReceiptLong as ReceiptLongIcon,
  People as PeopleIcon,
  Settings as SettingsIcon,
  WarehouseOutlined,
  PendingActionsOutlined,
  AccountBalance,
} from "@mui/icons-material";
import { useNavigate } from "react-router-dom";

const DRAWER_OPEN = 240;
const DRAWER_CLOSED = 72;

export default function AppShellCobros({
  title = "Bankivo",
  brand = "Bankivo",
  rightContent = null,
  children,
}) {
  const theme = useTheme();
  const mdUp = useMediaQuery(theme.breakpoints.up("md"));
  const [navOpen, setNavOpen] = React.useState(true);
  const navigate = useNavigate();
  const navItems = [
    { icon: <PosIcon />, label: "Facturar" , onClick: () => navigate("/gestion_comercial/centro_cobros")},
    { icon: <PeopleIcon />, label: "Clientes" , onClick: () => navigate("/gestion_comercial/centro_cobros/clientes")},
    {icon: <PendingActionsOutlined />, label: "Turnos" , onClick: () => navigate("/gestion_comercial/centro_cobros/gestion_turnos/historialturnos")},
    {icon: <AccountBalance />, label: "Gastos" , onClick: () => navigate("/gestion_comercial/centro_cobros/gastos")},
   // {icon: <WarehouseOutlined />, label: "Inventario" , onClick: () => navigate("/gestion_comercial/centro_cobros/inventario")}
  ];


  const drawerVariant = mdUp ? "permanent" : "temporary";
  const navWidth = mdUp ? (navOpen ? DRAWER_OPEN : DRAWER_CLOSED) : 0;

  return (
    <Box sx={{ display: "flex", minHeight: "100vh", bgcolor: "grey.50" }}>
      <CssBaseline />

      {/* AppBar */}
      <AppBar
        position="fixed"
        color="white"
        elevation={0}
        sx={{
          borderBottom: 1,
          borderColor: "divider",
          width: { md: `calc(100% - ${navWidth}px)` },
          ml: { md: `${navWidth}px` },
          transition: "margin-left .2s ease, width .2s ease",
        }}
      >
        <Toolbar sx={{backgroundColor:"white"}}>
          <Typography variant="h6" sx={{ fontWeight: 800 }}>
            {title}
          </Typography>
          <Box sx={{ flexGrow: 1 }} />
          {rightContent}
        </Toolbar>
      </AppBar>

      {/* Drawer */}
      <Drawer
        variant={drawerVariant}
        open={navOpen}
        onClose={() => setNavOpen(false)}
        ModalProps={{ keepMounted: true }}
        PaperProps={{
          sx: {
            width: mdUp ? (navOpen ? DRAWER_OPEN : DRAWER_CLOSED) : DRAWER_OPEN,
            overflowX: "hidden",
            borderRight: "1px solid",
            borderColor: "divider",
            transition: "width .2s ease",
          },
        }}
      >
        <Toolbar sx={{ px: 1 }}>
          <IconButton onClick={() => navigate("/gestion_comercial/prestamos")}>
             {mdUp ? (navOpen ? <ChevronLeftIcon /> : <MenuIcon />) : <MenuIcon />}
          </IconButton>

          <Typography
            variant="h6"
            sx={{ fontWeight: 800, display: { md: navOpen ? "block" : "none" }, ml: 2 }}
          >
            {brand}
          </Typography>

        </Toolbar>
        <Divider />
        <List sx={{ px: 1 }}>
          {navItems.map(({ key, icon, label, onClick }) => (
            <ListItemButton key={key || label} onClick={onClick} sx={{ borderRadius: 2, mb: 0.5 }}>
              <ListItemIcon sx={{ minWidth: 40 }}>{icon}</ListItemIcon>
              <ListItemText
                primary={label}
                sx={{ display: { md: navOpen ? "block" : "none" } }}
              />
            </ListItemButton>
          ))}
        </List>
      </Drawer>

      {/* Main */}
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          pt: 8,
          pl: { md: `${navWidth}px` },
          transition: "padding-left .2s ease",
        }}
      >
        {children}
      </Box>
    </Box>
  );
}
